import {
  ResultEnum
} from 'libs/enums.js';

export default class BatchFactory {
  /**
   * @static
   * @param {*} batcher
   * @param {*} onSuccess
   * @param {*} callbacks
   * @returns
   * @memberof BatchFactory
   */
  static BatchComplete(batcher, onSuccess, ...callbacks) {
    
    return (results) => {
      let failedresults = results.filter(x => x.result === ResultEnum.FAILED);
      let ignoredresults = results.filter(x => x.result === ResultEnum.IGNORED);
      if (failedresults.length === 0 && ignoredresults.length === 0) {
        // success
        batcher.closeModal();
        if (onSuccess) {
          onSuccess();
        }
      } else {
        // has error(s)
        batcher.hideSuccess();
      }
      if (callbacks && callbacks.length > 0) {
        // always:
        for (let callback of callbacks) {
          callback();
        }
      }
    };
  }

  /**
   * @static
   * @param {*} batcher
   * @param {*} items
   * @param {*} title
   * @param {*} method
   * @param {*} onComplete
   * @memberof BatchFactory
   */
  static BatchStart(batcher, items, title, method, onComplete, confirmBefore, confirmMessage) {

    const startMethod =  () => {
      batcher.title = title;
      batcher.items = items;
      batcher.completeMethod = onComplete;
      batcher.batchMethod = BatchFactory.GenerateAsyncBatchMethod(method);
      batcher.showModal();
    };

    if (!confirmBefore) {
      startMethod();
    } else {
      batcher.$dialogs.confirm(
        confirmMessage,
        title,
        startMethod);
    }
  }
  
  /**
   * @param {*} asyncMethod
   * @returns
   * @memberof BatchFactory
   */
  static GenerateAsyncBatchMethod(asyncMethod) {
    return async (item) => {
      item.result = ResultEnum.PENDING;
        await asyncMethod(item.data).then(res => {
        console.log('GenerateAsyncBatchMethod - success');
        item.result = ResultEnum.SUCCESS;
      }).catch(error => {
        // server can deny batchitems, marking them as ignored.
        if (error.Status != null && error.Status === ResultEnum.IGNORED) {
          item.result = ResultEnum.IGNORED;
        } else {
          item.result = ResultEnum.FAILED;
        }
        item.error = error.Error;
        console.log('GenerateAsyncBatchMethod - error');
      });
      return item;
    };
  }

  static BatchCompleteExtended(keepOpenOnSuccess, showAllOnFail, batcher, onSuccess, ...callbacks) {
    
    return (results) => {
      let failedresults = results.filter(x => x.result === ResultEnum.FAILED);
      let ignoredresults = results.filter(x => x.result === ResultEnum.IGNORED);
      if (failedresults.length === 0 && ignoredresults.length === 0) {
        // success
        if (!keepOpenOnSuccess) {
          batcher.closeModal();
        }
        if (onSuccess) {
          onSuccess();
        }
      } else {
        // has error(s)
        if (!showAllOnFail) {
          batcher.hideSuccess();
        }
      }
      if (callbacks && callbacks.length > 0) {
        // always:
        for (let callback of callbacks) {
          callback();
        }
      }
    };
  }

  static BatchStartExtended(batcher, items, title, method, onComplete) {
    batcher.title = title;
    batcher.items = items;
    batcher.completeMethod = onComplete;
    batcher.batchMethod = BatchFactory.GenerateAsyncBatchExtendedMethod(method);
    batcher.showModal();
  }
  /**
   * @param {*} asyncMethod
   * @returns
   * @memberof BatchFactory
   */
  static GenerateAsyncBatchExtendedMethod(asyncMethod) {
    return async (item) => {
      item.result = ResultEnum.PENDING;
        await asyncMethod(item.data).then(res => {
        item.result = ResultEnum.SUCCESS;
        item.ID = res.ID;
        item.AutoID = res.AutoID;
      }).catch(error => {
        // server can deny batchitems, marking them as ignored.
        if (error.Status != null && error.Status === ResultEnum.IGNORED) {
          item.result = ResultEnum.IGNORED;
        } else {
          item.result = ResultEnum.FAILED;
        }
        item.error = error.Error;
      });
      return item;
    };
  }
}
